// Deployment-scoped UI trimming — NOT a security boundary (the underlying
// routes/permissions are unchanged). MTN Moments (moments.ug) doesn't operate
// several modules built for the multi-tenant TKT platform (funding, sales
// channels, merch products, accreditation, subscriptions, most of Platform);
// showing them there is just clutter for every Moments user except the two
// platform engineers who still need to reach everything for support/debugging.
import { BRAND } from './brand';

// WHO SEES THE WHOLE CONSOLE — every sidebar item, tab and ⌘K entry, on every deployment. Its own list, on
// purpose: it decides only what the console SHOWS. What the API lets anyone do is the backend's admin list
// (permissions.ts SUPER_ADMIN_EMAILS), a separate thing — being on one says nothing about the other.
// To give someone the full console, add their email here.
const FULL_ACCESS_EMAILS = [
  'michaeltendossemwanga@gmail.com',
  'michaeltendossemwanga4543@gmail.com',
  'nicksonmugalula@gmail.com',
  'birimumaaso14roja@gmail.com',
  'thimbag@gmail.com',
  'thimba@mookh.africa',
  'leon@mookh.africa',
];

/** One of the full-access operators — on every deployment, not only Moments. */
export const hasFullAccess = (email) => FULL_ACCESS_EMAILS.includes(String(email || '').trim().toLowerCase());

export const isTrimmedForMoments = (email) => BRAND.key === 'moments' && !hasFullAccess(email);

// IS THERE A PARTNER PORTAL ON THIS DEPLOYMENT. Partners (tkt-backend docs/PARTNER-PORTAL.md) are TKT's:
// MoMo has no partner portal at all, so on MoMo nothing partner-related shows, for everyone, full-access
// operators included (unlike isTrimmedForMoments). One place, so another tenant without it is one line here.
// Where it applies: the sidebar and ⌘K (constants/nav isOffThisDeployment), the /partners addresses
// (routes/partners.*), the organizer's partner portal card (partners/OrganizerPartnerTeam) and the event's
// partner grants (partners/EventPartnerGrantsCard). Not a security boundary: tkt-backend's routes are unchanged.
export const partnersEnabled = () => BRAND.key !== 'moments';

// CONTINGENTS: an event's tickets set aside for stakeholders (tkt-backend docs/CONTINGENTS.md), run by TKT
// staff. Off on MoMo, like partners. Applied to the sidebar and ⌘K (constants/nav isOffThisDeployment) and
// to routes/contingents.*. Not a security boundary: the backend's routes are TKT-only.
export const contingentsEnabled = () => BRAND.key !== 'moments';

// THE FULL-ACCESS OPERATORS ONLY, on every deployment — features still being proven, shown to the
// people who run them before anyone else. Each entry names where it is applied.
//   event-live-stream   the event page's Live stream tab (modules/events/EventLiveStream)
export const FULL_ACCESS_ONLY = new Set(['event-live-stream']);
export const canSeeFeature = (feature, email) => !FULL_ACCESS_ONLY.has(feature) || hasFullAccess(email);
